export enum ResultStatus {
  ACCEPTED = 'verification.accepted',
  DECLINED = 'verification.declined',
}

export const resultStatusMapping: Record<ResultStatus, string> = {
  [ResultStatus.ACCEPTED]: 'SHUFTI.ENQUIRIES.STATUS_OPTIONS.ACCEPTED',
  [ResultStatus.DECLINED]: 'SHUFTI.ENQUIRIES.STATUS_OPTIONS.DECLINED',
};
